module.exports = __webpack_public_path__ + "static/media/actor-1.7421b5dd.jpg";